import { Routes } from '@angular/router';
import { userManagementRoutes } from '@app/features/admin/user-management/user-management.routes';
import { vendorManagementRoutes } from '@app/features/admin/vendor-management/vendor-management.routes';
import { configurationsRoutes } from '@app/features/admin/configurations/configurations.routes';
import { vendorRoutes } from '@app/features/vendor/vendor.routes';

/**
 * Route anak `main-layout`. Sengaja minimal: komponen fitur (master data, purchase
 * requisition, vendor management, CMS, dst) belum ada di project ini. Tambahkan
 * bertahap seiring fiturnya dibuat — jangan salin 40+ route dari base yang
 * komponennya tidak ada.
 *
 * `title` memakai key i18n (`I18nTitleStrategy`), bukan string mentah.
 */
export const mainLayoutRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadComponent: () => import('@shared/pages/home/home.component').then((c) => c.HomeComponent),
    title: 'routes.home',
  },
  {
    // Area Master Data — child-nya (purch_orgs, plants, currencies, dst) di master-data.routes.
    // URL: /admin/master/<child>. `master` cocok dengan prefix path menu BE.
    path: 'master',
    loadChildren: () =>
      import('@app/features/admin/master-data/master-data.routes').then((m) => m.masterDataRoutes),
  },
  // Area User Management — path-nya rata di root shell (mis. /admin/personnels), tanpa segmen
  // prefix, mengikuti `navigable.path` dari menu BE. Tiap entry tetap lazy (loadComponent).
  {
    // Area CMS — child-nya (pages, dst) di cms.routes. URL: /admin/cms/<child>.
    // Bersegmen seperti `master`, jadi memakai loadChildren; bukan spread rata seperti
    // user-management yang path menunya memang tanpa prefix.
    path: 'cms',
    loadChildren: () => import('@app/features/admin/cms/cms.routes').then((m) => m.cmsRoutes),
  },
  ...userManagementRoutes,
  // Area Vendor Management — sama polanya: path rata di root shell (mis. /admin/applicants).
  ...vendorManagementRoutes,
  // Area Configurations — path rata di root shell juga (/admin/configurations).
  ...configurationsRoutes,
  // Area situs VENDOR (menu vendor: profil & tab-tabnya, mis. /vendor/profile).
  //
  // WAJIB PALING BAWAH: entry-nya ber-path '' dengan children, jadi ia dicoba untuk SETIAP URL
  // yang belum tertangani route di atasnya. Kalau tak ada child yang cocok, router mundur
  // (Recognizer.processSegment menangkap NoMatch lalu lanjut ke route berikutnya) sehingga URL
  // tak dikenal tetap jatuh ke '**' → 404. Menaruhnya lebih atas hanya memperlambat pencocokan
  // route lain — tidak ada alasan melakukannya.
  ...vendorRoutes,
];
